import { Navigate } from 'react-router-dom'
import { isMultilangPocEnabled } from '../../../constants/featureFlags'
import { useProjectId } from '../../../hooks/useProjectId'
import { useSurveyId } from '../../../hooks/useSurveyId'
import Translations from './Translations'

// The route is registered either way, because `validateSurveyPath` whitelists
// /translations — leaving it out renders the survey chrome around an empty
// content area for a bookmarked URL.
//
// Deliberately gated on the feature grant alone, NOT on
// useSingleMarketTranslationsEnabled. That gate depends on fieldwork +
// questionnaire + audience queries and reports `false` until they resolve, so
// deciding a redirect on it sent a hard reload of this URL to /questionnaire
// before the evidence loaded — worst for the case it exists to serve, a
// colleague whose browser has no local declaration and whose survey needs
// translating only because translations are already stored against it.
//
// Waiting on a loading flag instead doesn't work here: useGetDraftQuestionnaire
// wraps useLazyQuery, whose `loading` is still false on the first render (it
// fires in a useLayoutEffect), and a data-presence check never resolves if a
// query errors — turning a recoverable redirect into a permanently blank page.
// Depending only on a synchronous cookie read removes the race entirely.
//
// So a bookmarked URL for a survey that doesn't need translating opens the
// editor with an empty language sidebar rather than redirecting. That still
// satisfies the no-blank-page goal, and the breadcrumb remains the only way in.
export const TranslationsRoute = () => {
  const projectId = useProjectId()
  const surveyId = useSurveyId()

  return isMultilangPocEnabled() ? (
    <Translations />
  ) : (
    <Navigate
      to={`/project/${projectId}/survey/${surveyId}/questionnaire`}
      replace
    />
  )
}

export default TranslationsRoute
